import React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@lemonadetraining/web-ui";
import { IconX } from "@tabler/icons-react";

/* own module */
import * as PROGRAMMING from "@lemonadetraining/web-shared/constants/ProgrammingConst";

const TimelineWeekDay = (props) => {
  // --------[Render]---------
  return (
    <>
      {props.week && (
        <span className="inline-flex items-center rounded-full border border-primary px-2 py-0.5 text-xs text-primary mr-1">
          {`Week ${props.week}`}
        </span>
      )}
      {props.day && (
        <span className="inline-flex items-center rounded-full border border-primary px-2 py-0.5 text-xs text-primary mr-1">
          {`${PROGRAMMING.DAYS[props.day]}`}
          {props.editMode && (
            <button
              onClick={() => {
                if (props.onDayUpdate) props.onDayUpdate(null);
              }}
              className="ml-1 text-muted-foreground hover:text-foreground"
            >
              <IconX className="size-3" />
            </button>
          )}
        </span>
      )}
      {!props.day && props.editMode && (
        <Select
          value={undefined}
          onValueChange={(newValue) => {
            const dayIndex = PROGRAMMING.DAYS.indexOf(newValue);
            if (props.onDayUpdate) props.onDayUpdate(dayIndex >= 0 ? dayIndex : null);
          }}
        >
          <SelectTrigger className="h-7 text-xs w-auto">
            <SelectValue placeholder="Day" />
          </SelectTrigger>
          <SelectContent>
            {PROGRAMMING.DAYS.map((day, index) => (
              <SelectItem key={index} value={day}>
                {day}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </>
  );
};

export default TimelineWeekDay;
